import { Component, Prop, Vue } from 'vue-property-decorator'
interface ScopeType {
  row?: Record<string, any>
  index?: number
  column?: any
}
@Component
export default class AmTableCustomRender extends Vue {
  @Prop({ type: Function, required: false }) 
  readonly renderFunc?: (h: Vue.CreateElement, scope: ScopeType) => any
  
  @Prop({ type: Object, default: () => ({}) })
  readonly scope!: ScopeType

  get renderedContent() {
    return this.renderFunc?.(this.$createElement, this.scope) || '---'
  }

  render() {
    return this.renderedContent
  }
}
